var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.5067 11.75C10.5067 12.9006 11.4379 13.8333 12.5865 13.8333C13.7352 13.8333 14.6663 12.9006 14.6663 11.75C14.6663 10.5994 13.7352 9.66666 12.5865 9.66666C11.4379 9.66666 10.5067 10.5994 10.5067 11.75ZM10.5067 11.75H8.42743C5.67511 11.75 3.44392 9.51504 3.44392 6.75808V5.50105M5.49266 3.41666C5.49266 4.56725 4.56149 5.49999 3.41283 5.49999C2.26418 5.49999 1.33301 4.56725 1.33301 3.41666C1.33301 2.26607 2.26418 1.33333 3.41283 1.33333C4.56149 1.33333 5.49266 2.26607 5.49266 3.41666Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCategory);
export default __webpack_public_path__ + "static/media/main-category.a01ebb0690def398370dc32a0519b834.svg";
export { ForwardRef as ReactComponent };